"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[824],{

/***/ 12774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$W": function() { return /* binding */ hexToRGB; },
/* harmony export */   "zP": function() { return /* binding */ MediaQuery; }
/* harmony export */ });
/* unused harmony exports ProfitOrLossCheck, currencyFormat */
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30511);



function MediaQuery(screen, measure) {
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.a)();
    var bpSwitch = function(screenType) {
        switch(screenType){
            case "sm":
                return theme.screens.sm;
            case "md":
                return theme.screens.md;
            case "lg":
                return theme.screens.lg;
            case "xl":
                return theme.screens.xl;
            case "xxl":
                return theme.screens.xxl;
        }
    };
    return "@media (".concat(measure, "-width: ").concat(bpSwitch(screen), ")");
}
function ProfitOrLossCheck(param) {
    var percentage = param.percentage, background = param.background;
    percentage = "".concat(percentage);
    return /*#__PURE__*/ _jsxs("span", {
        css: function(theme) {
            return /*#__PURE__*/ css(background ? "background-color: ".concat(percentage.charAt(0) == "-" ? theme.colors.danger : theme.colors.success, ";\n                    color: ").concat(theme.colors.white, ";\n                    border-radius: ").concat(theme.borderRadius.full, ";\n                    justify-content: center;\n                    align-items: center;\n                    display: flex;\n                    ", "\n                    height: 3.5rem;\n                    width: 3.5rem;\n                    flex-direction: column;\n\n                    ") : "color: ".concat(percentage.charAt(0) == "-" ? theme.colors.danger : theme.colors.success, ";"));
        },
        children: [
            percentage.charAt(0) == "-" ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BsArrowDownShort, {
                        className: "inline-block"
                    }),
                    percentage.replace("-", "")
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BsArrowUpShort, {
                        className: "inline-block"
                    }),
                    percentage
                ]
            }),
            "%"
        ]
    });
}
function currencyFormat(num, type, count) {
    return Intl.NumberFormat(count, {
        style: "currency",
        currency: type
    }).format(num);
}
function hexToRGB(h, o) {
    var r = 0, g = 0, b = 0;
    // 3 digits
    if (h.length == 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];
    // 6 digits
    } else if (h.length == 7) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
    }
    return "rgb(" + +r + "," + +g + "," + +b + "," + o + ")";
}


/***/ }),

/***/ 86481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ base_ui_Accordion; },
  "qE": function() { return /* reexport */ base_ui_Avatar; },
  "zx": function() { return /* reexport */ base_ui_Button; },
  "hE": function() { return /* reexport */ base_ui_ButtonGroup; },
  "Zb": function() { return /* reexport */ base_ui_Card; },
  "iz": function() { return /* reexport */ base_ui_Divider; },
  "TT": function() { return /* reexport */ base_ui_FeatureCard; },
  "l0": function() { return /* reexport */ base_ui_Form; },
  "rU": function() { return /* reexport */ base_ui_Link; },
  "EX": function() { return /* reexport */ base_ui_PartnerLogo; },
  "$0": function() { return /* reexport */ base_ui_Section; },
  "OK": function() { return /* reexport */ base_ui_Tab; },
  "x4": function() { return /* reexport */ base_ui_TabPanel; },
  "Vp": function() { return /* reexport */ base_ui_Tag; },
  "Dx": function() { return /* reexport */ base_ui_Title; },
  "ZT": function() { return /* reexport */ base_ui_Typography; }
});

// UNUSED EXPORTS: Carousel, Pagination, Svg, Table, TableCoins

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/features/base-ui/Svg.jsx
/* eslint-disable @next/next/no-img-element */ 



function Svg(param) {
    var src = param.src, color = param.color, className = param.className;
    if (src.includes("/api/storage")) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: className,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;& svg{width:100%;height:100%;}"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                alt: "",
                src: src
            })
        });
    } else {
        if (color) {
            var match = src.match(/fill="\w{18}"/);
            if (match) {
                src = src.replace(new RegExp(match[0]), "");
            }
            src = src.replace(/<svg/, '<svg fill="'.concat(color, '"'));
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: className,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;& svg{width:100%;height:100%;}"),
            dangerouslySetInnerHTML: {
                __html: src
            }
        });
    }
}
Svg.propTypes = {
    src: (prop_types_default()).string.isRequired,
    color: (prop_types_default()).string
};
/* harmony default export */ var base_ui_Svg = ((/* unused pure expression or super */ null && (Svg)));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/features/base-ui/Link.js




// const isURL = (str) => {
//     const pattern = new RegExp(
//         '^https?:\\/\\/' + // protocol,
//             'i'
//     ) // fragment locator
//     return !!pattern.test(str)
// }
var Link = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, href = param.href, _external = param.external, external = _external === void 0 ? false : _external, target = param.target, download = param.download, className = param.className, style = param.style, color = param.color, hoverColor = param.hoverColor, onClick = param.onClick, backgroundColor = param.backgroundColor;
    /* eslint-disable indent */ var linkCss = function(theme) {
        return "\n        color: ".concat(theme.colors[color] || theme.colors.medGray, "; ").concat(backgroundColor ? "" : "&:hover {\n                    color: ".concat(theme.colors[hoverColor] || theme.colors.primary, ";\n                }"), "\n                \n                cursor: pointer;\n                ");
    };
    var bgLink = function(theme) {
        return "\n        cursor: pointer;\n        ".concat(backgroundColor && "background-color: ".concat(theme.colors[backgroundColor], ";\n             &:hover {\n                    box-shadow: ").concat(theme.boxShadow.lg, ";\n                }"), ";\n        ").concat(style, "\n            ");
    };
    /* eslint-enable indent */ var linkBody = external === true ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: "external-link",
        css: bgLink,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: href,
            download: download,
            target: target,
            css: linkCss,
            onClick: onClick,
            ref: ref,
            children: children
        })
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: "internal-link",
        css: bgLink,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                onClick: onClick,
                css: linkCss,
                ref: ref,
                children: children
            })
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)("link inline-block", className),
        children: linkBody
    });
});
/* harmony default export */ var base_ui_Link = (Link);

;// CONCATENATED MODULE: ./src/features/base-ui/Typography.js


//+++++++++++++++++++++++++++++++++++
//* font-weight numeric & named value
//* 100 Thin
//* 200 Extra Light
//* 300 Light
//* 400 Normal
//* 500 Medium
//* 600 Semi Bold
//* 700 Bold
//* 800 Extra Bold
//* 900 Ultra Bold
//++++++++++++++++++++++++++++++++++
//* font-size Heading giude
//* h1: 2.5rem
//* h2: 2.2rem
//* h3: 1.7rem
//* h4: 1.4rem
//* h5: 1.2rem
//* h6: 1.05rem
//++++++++++++++++++++++++++++++++++
//* line-height guide
//* default: 1.167
//* paragraph: 1.5
//++++++++++++++++++++++++++++++++++
//                            css={(theme) => ({color: theme.colors.medGray})}
function Typography_Typography(param) {
    var _type = param.type, type = _type === void 0 ? "t" : _type, children = param.children, color = param.color, fontWeight = param.fontWeight, lineHeight = param.lineHeight, _align = param.align, align = _align === void 0 ? "start" : _align, lineClamp = param.lineClamp, className = param.className, hoverColor = param.hoverColor, fontSize = param.fontSize, _transform = param.transform, transform = _transform === void 0 ? "none" : _transform, style = param.style;
    var fontWeightSwitch = function(weightName) {
        switch(weightName){
            case "Thin":
                return "100";
            case "Extra Light":
                return "200";
            case "Light":
                return "300";
            case "Normal":
                return "400";
            case "Medium":
                return "500";
            case "Semi Bold":
                return "600";
            case "Bold":
                return "700";
            case "Extra Bold":
                return "800";
            case "Ultra Bold":
                return "900";
        }
    };
    /* eslint-disable */ var typoCss = function(theme) {
        var themeTypography = theme.typography[type];
        return "\n            margin-bottom: 0.35rem;\n            font-size: ".concat(fontSize || themeTypography.fontSize, ";\n            line-height: ").concat(lineHeight || themeTypography.lineHeight, ";\n            font-weight: ").concat(fontWeightSwitch(fontWeight) || themeTypography.fontWeight, ";\n            text-align: ").concat(align, ";\n            color: ").concat(theme.colors[color] || theme.colors.text, ";\n            overflow: ").concat(lineClamp ? "hidden" : "", ";\n            display: ").concat(lineClamp ? "-webkit-box" : "", ";\n            -webkit-box-orient: ").concat(lineClamp ? "vertical" : "", ";\n            -webkit-line-clamp: ").concat(lineClamp ? lineClamp : "", ";\n            ").concat(hoverColor && "&:hover {\n                    color: ".concat(theme.colors[hoverColor], ";\n                }"), ";\n            text-transform: ").concat(transform, ";\n            ").concat(style, ";\n        ");
    };
    /* eslint-enable */ var typoSwitch = function(hType) {
        switch(hType){
            case "h1":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    className: (0,clsx_m/* default */.Z)("typography h1", className),
                    css: typoCss,
                    children: children
                });
            case "h2":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    className: (0,clsx_m/* default */.Z)("typography h2", className),
                    css: typoCss,
                    children: children
                });
            case "h3":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                    className: (0,clsx_m/* default */.Z)("typography h3", className),
                    css: typoCss,
                    children: children
                });
            case "h4":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                    className: (0,clsx_m/* default */.Z)("typography h4", className),
                    css: typoCss,
                    children: children
                });
            case "h5":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h5", {
                    className: (0,clsx_m/* default */.Z)("typography h5", className),
                    css: typoCss,
                    children: children
                });
            case "h6":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h6", {
                    className: (0,clsx_m/* default */.Z)("typography h6", className),
                    css: typoCss,
                    children: children
                });
            case "p":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    className: (0,clsx_m/* default */.Z)("typography p", className),
                    css: typoCss,
                    children: children
                });
            case "t":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: (0,clsx_m/* default */.Z)("typography t", className),
                    css: typoCss,
                    children: children
                });
            case "div":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: (0,clsx_m/* default */.Z)("typography", className),
                    css: typoCss,
                    children: children
                });
        }
    };
    return typoSwitch(type);
}
/* harmony default export */ var base_ui_Typography = (Typography_Typography);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 1 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(30511);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/features/base-ui/Utility.js
var Utility = __webpack_require__(12774);
;// CONCATENATED MODULE: ./src/features/base-ui/Card.js





function Card_Card(param) {
    var _type = param.type, type = _type === void 0 ? "default" : _type, _align = param.align, align = _align === void 0 ? "start" : _align, header = param.header, imgSrc = param.imgSrc, _imgWidth = param.imgWidth, imgWidth = _imgWidth === void 0 ? "500" : _imgWidth, _imgHeight = param.imgHeight, imgHeight = _imgHeight === void 0 ? "200" : _imgHeight, _imgLayout = param.imgLayout, imgLayout = _imgLayout === void 0 ? "intrinsic" : _imgLayout, _borderStyle = param.borderStyle, borderStyle = _borderStyle === void 0 ? "rounded" : _borderStyle, color = param.color, subtitle = param.subtitle, horizentalImageSize = param.horizentalImageSize, title = param.title, _imgFullRound = param.imgFullRound, imgFullRound = _imgFullRound === void 0 ? false : _imgFullRound, children = param.children, bordered = param.bordered, className = param.className, shadow = param.shadow, _spacing = param.spacing, spacing = _spacing === void 0 ? "lg" : _spacing, footer = param.footer, style = param.style;
    var switchBorderStyle = function switchBorderStyle(style) {
        switch(style){
            case "rounded":
                return theme.borderRadius.lg;
            case "square":
                return "0";
        }
    };
    var imageSizeSwitch = function imageSizeSwitch(size) {
        switch(size){
            case "narrow":
                return "30%";
            case "wide":
                return "100%";
            case "normal":
                return "60%";
            default:
                return "60%";
        }
    };
    var paddingSwitch = function paddingSwitch(space) {
        var spacing = theme.spacing;
        switch(space){
            case "xs":
                return spacing.one;
            case "sm":
                return spacing.two;
            case "md":
                return spacing.four;
            case "lg":
                return spacing.six;
            case "xl":
                return spacing.eight;
            case "xxl":
                return spacing.ten;
            default:
                return spacing.six;
        }
    };
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var mainStyle = "\n        background-color: ".concat(color || theme.colors.white, ";\n        ").concat(shadow && "box-shadow: ".concat(theme.boxShadow[shadow]), ";\n        border-radius: ").concat(switchBorderStyle(borderStyle), ";\n        ").concat(bordered && "border: 1px solid ".concat(theme.colors.lighterGray), ";\n        padding: ").concat(paddingSwitch(spacing), ";\n        ").concat(style, ";\n    ");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            type === "default" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: (0,clsx_m/* default */.Z)("card default-card vertical-card", className),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(mainStyle),
                children: [
                    header && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "px-10 py-2",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
                        children: header
                    }),
                    imgSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        priority: true,
                        src: imgSrc,
                        alt: title,
                        width: imgWidth,
                        height: imgHeight,
                        layout: "responsive",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;", imgFullRound && (header ? "border-radius: 0;" : /* eslint-disable indent */ "border-radius: ".concat(switchBorderStyle(borderStyle), ";")), ";", !imgFullRound && (header ? "border-top-left-radius: 0; border-top-right-radius: 0;" : /* eslint-disable indent */ "border-top-left-radius:".concat(switchBorderStyle(borderStyle), "; \n                                      border-top-right-radius:").concat(switchBorderStyle(borderStyle), ";")), ";/* eslint-enable indent */")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "container",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:", paddingSwitch(spacing), ";height:100%;"),
                        children: [
                            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-subtitle",
                                children: subtitle
                            }),
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-title mt-2",
                                children: title
                            }),
                            children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-content h-full",
                                children: children
                            }),
                            footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-footer",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;display:flex;"),
                                children: footer
                            })
                        ]
                    })
                ]
            }),
            type === "horizental" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: (0,clsx_m/* default */.Z)("card horizental-card", className),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:100%;", align === "start" && "flex-direction: row", ";", align === "end" && "flex-direction: row-reverse", ";", mainStyle),
                children: [
                    imgSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", imageSizeSwitch(horizentalImageSize), ";position:relative;", (0,Utility/* MediaQuery */.zP)("md", "max"), "{width:", imageSizeSwitch("normal"), ";}text-align:center;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            priority: true,
                            src: imgSrc,
                            alt: title,
                            layout: imgLayout,
                            width: imgWidth,
                            height: imgHeight,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;", "" /* ${!imgFullRound &&
                                    align === 'start' &&
                                    `border-top-right-radius: ${switchBorderStyle(
                                        borderStyle
                                    )};
                                border-bottom-right-radius: ${switchBorderStyle(
                                    borderStyle
                                )};`};
                                    ${!imgFullRound &&
                                    align === 'end' &&
                                    `border-top-left-radius: ${switchBorderStyle(
                                        borderStyle
                                    )};
                                border-bottom-left-radius: ${switchBorderStyle(
                                    borderStyle
                                )};`} */ , " ", imgFullRound && "border-radius: ".concat(switchBorderStyle(borderStyle), ";"), ";")
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "container",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:100%;"),
                        children: [
                            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-subtitle px-4 my-2",
                                children: subtitle
                            }),
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-title pt-1 px-4",
                                children: title
                            }),
                            children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-content px-4 mt-2",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("align-self:start;"),
                                children: children
                            }),
                            footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "card-footer",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:20px;display:flex;"),
                                children: footer
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var base_ui_Card = (Card_Card);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var src_tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/features/base-ui/Button.js




function _templateObject() {
    var data = (0,src_tagged_template_literal/* default */.Z)([
        "\n            ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Button_Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var icon = _param.icon, href = _param.href, children = _param.children, target = _param.target, onClick = _param.onClick, download = _param.download, type = _param.type, color = _param.color, _external = _param.external, external = _external === void 0 ? true : _external, hoverColor = _param.hoverColor, size = _param.size, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, backgroundColor = _param.backgroundColor, style = _param.style, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "href",
        "children",
        "target",
        "onClick",
        "download",
        "type",
        "color",
        "external",
        "hoverColor",
        "size",
        "className",
        "disabled",
        "backgroundColor",
        "style"
    ]);
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var buttonSize = function(bSize) {
        switch(bSize){
            case "x-small":
                return "\n                    font-size: ".concat(theme.fontSize.xs, ";\n                    padding: ").concat(theme.spacing.one, ";\n                ");
            case "small":
                return "\n                    font-size: ".concat(theme.fontSize.sm, ";\n                    padding: ").concat(theme.spacing.one, ";\n                ");
            case "medium":
                return "font-size: ".concat(theme.fontSize.base, "; ").concat(type === "link" ? "padding: ".concat(theme.spacing.two, ";") : "padding: ".concat(theme.spacing.one, " ").concat(theme.spacing.two, ";"), ";\n                    ");
            case "large":
                return "font-size: ".concat(theme.fontSize.lg, "; ").concat(type === "link" ? "padding: ".concat(theme.spacing.three, ";") : "padding: ".concat(theme.spacing.four, " ").concat(theme.spacing.five, ";"), ";");
            default:
                return "font-size: ".concat(theme.fontSize.base, "; ").concat(type === "link" ? "padding: ".concat(theme.spacing.two, ";") : "padding: ".concat(theme.spacing.one, " ").concat(theme.spacing.two, ";"), ";\n            \n                    ");
        }
    };
    var bStyle = "\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: ".concat(theme.borderRadius.default, ";\n            ").concat(buttonSize(size), "\n            background-color: ").concat(theme.colors[backgroundColor], ";\n            color: ").concat(theme.colors[color], ";\n            outline: 0;\n            box-shadow: 0 0 0 0.2rem rgb(149 163 255 / 25%);\n            &:hover {\n                box-shadow: 0 0 0 0.2rem rgb(149 163 255 / 50%);\n                background-color: ").concat(theme.colors[hoverColor], ";\n                filter: contrast(120%);\n            }\n            ").concat(disabled && "filter: contrast(40%); &:hover {\n                    box-shadow: none;\n                    filter: contrast(40%);\n                }", ";\n            ").concat(style, ";\n        ");
    var buttonStyle = (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), bStyle);
    var sharedProps = {
        href: href,
        disabled: disabled,
        onClick: onClick
    };
    var linkBody = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "mx-1",
                children: children
            }),
            icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "mx-1",
                children: icon
            })
        ]
    });
    if (type === "link") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        external: external,
        hoverColor: hoverColor,
        className: (0,clsx_m/* default */.Z)("", className, buttonSize(size)),
        ref: ref
    }), props), {
        children: linkBody
    }));
    if (type === "linkButton") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        external: external,
        className: (0,clsx_m/* default */.Z)("link-button", className),
        style: bStyle,
        download: download,
        target: target,
        backgroundColor: backgroundColor,
        color: color,
        ref: ref
    }), props), {
        children: linkBody
    }));
    if (type === "submit") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        className: (0,clsx_m/* default */.Z)("submit cursor-pointer", className),
        css: buttonStyle,
        value: children,
        type: "submit",
        ref: ref
    }), props));
    //{clsx('link inline-block', className)}
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        className: (0,clsx_m/* default */.Z)("button", className),
        css: buttonStyle,
        ref: ref
    }), props), {
        children: linkBody
    }));
});
/* harmony default export */ var base_ui_Button = (Button_Button);

;// CONCATENATED MODULE: ./src/features/base-ui/Avatar.js



function Avatar(param) {
    var children = param.children, size = param.size, _imgSrc = param.imgSrc, imgSrc = _imgSrc === void 0 ? "/img/avatar.gif" : _imgSrc, alt = param.alt, _isImg = param.isImg, isImg = _isImg === void 0 ? true : _isImg, _rounded = param.rounded, rounded = _rounded === void 0 ? true : _rounded, _color = param.color, color = _color === void 0 ? "white" : _color, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "danger" : _bgColor, fontSize = param.fontSize, boxSize = param.boxSize;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    //TODO make into switch
    var tSize = "";
    if (size === "medium") {
        size = "40px";
        tSize = "1.2rem";
    } else if (size === "small") {
        size = "24px";
        tSize = "0.8rem";
    } else if (size === "large") {
        size = "56px";
        tSize = "1.8rem";
    } else if (fontSize || boxSize) {
        size = boxSize;
        tSize = fontSize;
    }
    if (isImg) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
            src: imgSrc,
            alt: alt,
            width: size,
            height: size,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(rounded === true ? "border-radius: 100px" : "border-radius: 2px", ";")
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", size, ";height:", size, ";overflow:hidden;display:flex;background-color:", theme.colors[bgColor], ";color:", theme.colors[color], ";justify-content:center;align-items:center;font-size:", tSize, ";padding:0;", rounded === true ? "border-radius: 100px" : "border-radius: 2px", ";"),
            children: children
        });
    }
}
/* harmony default export */ var base_ui_Avatar = (Avatar);

;// CONCATENATED MODULE: ./src/features/base-ui/Table.js


function Table_Table(param) {
    var className = param.className, head = param.head, children = param.children;
    var tableCss = function(theme) {
        var radius = theme.borderRadius.xl;
        var white = theme.colors.white;
        var primary = theme.colors.primary;
        var lightGray = theme.colors.lightGray;
        return "\n            th:first-of-type {\n                border-top-right-radius: ".concat(radius, ";\n            }\n            th {\n                position: relative;\n            }\n            th:last-child {\n                border-top-left-radius: ").concat(radius, ";\n            }\n            th:after {\n                content: '';\n                height: 70%;\n                width: 1px;\n                position: absolute;\n                right: 0;\n                top: 15%;\n                background-color: ").concat(white, ";\n            }\n            th:first-of-type:after {\n                background-color: transparent;\n            }\n            thead {\n                background-color: ").concat(primary, ";\n                color: ").concat(white, ";\n            }\n            tbody {\n                background: ").concat(white, ";\n                outline: 2px solid ").concat(primary, ";\n                outline-offset: -2px;\n                border-bottom-left-radius: ").concat(radius, ";\n                border-bottom-right-radius: ").concat(radius, ";\n            }\n            tr {\n                border-bottom: 1px solid ").concat(lightGray, "\n            }\n            td {\n                border-left: 1px solid ").concat(lightGray, ";\n            }\n            tr:last-child, td:last-child {\n                border: none;\n            }\n            tr:last-child {\n                td:first-of-type {\n                    border-bottom-right-radius: ").concat(radius, ";\n                }\n                td:last-child {\n                    border-bottom-left-radius: ").concat(radius, ";\n                }\n            }\n            td, th {\n                padding: ").concat(theme.spacing.two, "\n            }\n        ");
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full ".concat(className),
        children: /*#__PURE__*/ _jsxs("table", {
            className: "w-full text-center",
            css: tableCss,
            children: [
                /*#__PURE__*/ _jsx("thead", {
                    children: /*#__PURE__*/ _jsx("tr", {
                        children: head.map(function(item, idx) {
                            return /*#__PURE__*/ _jsx("th", {
                                children: item
                            }, idx);
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("tbody", {
                    children: children
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_Table = ((/* unused pure expression or super */ null && (Table_Table)));

// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
;// CONCATENATED MODULE: ./src/features/base-ui/Tag.jsx





//TODO add a solid state and color
function Tag(param) {
    var children = param.children, href = param.href, rounded = param.rounded, closeBtn = param.closeBtn, className = param.className;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var ref = (0,react.useState)(true), visible = ref[0], setVisible = ref[1];
    var tagStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;font-size:", theme.fontSize.sm, ";", "" /* border: 1px solid ${ theme.colors.secGray}; */ , "        max-width:max-content;border-radius:", rounded ? theme.borderRadius.full : theme.borderRadius.default, ";padding:", theme.spacing.one, " ", theme.spacing.three, ";color:", theme.colors.medGray, ";background-color:", theme.colors.lighterGray, ";&:hover{", "" /* border-color: ${theme.colors.medGray}; */ , "            cursor:pointer;background-color:", theme.colors.lightGray, ";a{color:", theme.colors.text, ";}}span.close{color:", theme.colors.secGray, ";font-size:", theme.fontSize.lg, ";&:hover{color:", theme.colors.medGray, ";}}", className);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: visible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: tagStyle,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Link, {
                    href: href,
                    color: theme.colors.medGray,
                    children: children
                }),
                closeBtn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: "close relative",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* IoIosCloseCircle */.FMH, {
                        className: "inline-block mr-2",
                        onClick: function() {
                            return setVisible(false);
                        }
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_Tag = (Tag);

;// CONCATENATED MODULE: ./src/features/base-ui/Tab.js




function Tab(param) {
    var tabs = param.tabs, children = param.children, justify = param.justify, className = param.className;
    var ref = (0,react.useState)(0), activeTab = ref[0], setActiveTab = ref[1];
    var activeColor = "secondary";
    var firstColor = "transparent";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (0,clsx_m/* default */.Z)("tabs flex flex-wrap justify-".concat(justify), className),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_ButtonGroup, {
                color: "lightGray",
                children: tabs.map(function(item, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Button, {
                        onClick: function() {
                            setActiveTab(idx);
                        },
                        backgroundColor: idx === activeTab ? activeColor : firstColor,
                        className: "p-4",
                        children: item.label
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "w-full basis-full pt-6",
                children: children[activeTab]
            })
        ]
    });
}
/* harmony default export */ var base_ui_Tab = (Tab);

;// CONCATENATED MODULE: ./src/features/base-ui/TabPanel.js


function TabPanel(param) {
    var children = param.children, index = param.index;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        index: index,
        children: children
    });
}
/* harmony default export */ var base_ui_TabPanel = (TabPanel);

;// CONCATENATED MODULE: ./src/features/base-ui/ButtonGroup.js




function ButtonGroup(param) {
    var children = param.children, backgroundColor = param.backgroundColor, color = param.color;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var borderRadius = theme.borderRadius.default;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;background-color:", theme.colors.dark, ";border-radius:", borderRadius, ";padding:0.25rem;button{border-radius:0;background-color:", theme.colors[backgroundColor], ";color:", theme.colors[color], ";}button:last-child{border-top-left-radius:", borderRadius, ";border-bottom-left-radius:", borderRadius, ";}button:first-of-type{border-top-right-radius:", borderRadius, ";border-bottom-right-radius:", borderRadius, ";}", (0,Utility/* MediaQuery */.zP)("md", "max"), "{flex-wrap:wrap;justify-content:center;button{border:0.125rem solid transparent;border-radius:", borderRadius, ";}}"),
        className: "button-group",
        children: children
    });
}
/* harmony default export */ var base_ui_ButtonGroup = (ButtonGroup);

// EXTERNAL MODULE: ./node_modules/keen-slider/keen-slider.min.css
var keen_slider_min = __webpack_require__(19409);
// EXTERNAL MODULE: ./node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(82730);
;// CONCATENATED MODULE: ./src/features/base-ui/Carousel.js




 // import from 'keen-slider/react.es' for to get an ES module

function Carousel(param) {
    var children = param.children, _rtl = param.rtl, rtl = _rtl === void 0 ? true : _rtl, _loop = param.loop, loop = _loop === void 0 ? false : _loop, _preview = param.preview, preview = _preview === void 0 ? {
        sm: 1,
        md: 2,
        lg: 4,
        xl: 6,
        xxl: 7
    } : _preview, _controls = param.controls, controls = _controls === void 0 ? true : _controls, className = param.className;
    var ref;
    var ref1 = _sliced_to_array(React.useState(0), 2), currentSlide = ref1[0], setCurrentSlide = ref1[1];
    var ref2 = useState(false), loaded = ref2[0], setLoaded = ref2[1];
    var ref3 = _sliced_to_array(useKeenSlider({
        slideChanged: function slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created: function created() {
            setLoaded(true);
        },
        rtl: rtl,
        loop: loop,
        breakpoints: {
            "(min-width: 640px)": {
                slides: {
                    perView: preview.md,
                    spacing: 5
                }
            },
            "(min-width: 1024px)": {
                slides: {
                    perView: preview.lg,
                    spacing: 15
                }
            },
            "(min-width: 1280px)": {
                slides: {
                    perView: preview.xl,
                    spacing: 15
                }
            },
            "(min-width: 1580px)": {
                slides: {
                    perView: preview.xxl,
                    spacing: 15
                }
            }
        },
        slides: {
            perView: preview.sm
        }
    }, []), 2), refCallback = ref3[0], instanceRef = ref3[1];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            css: /*#__PURE__*/ css("position:relative;"),
            className: className,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    ref: refCallback,
                    className: "keen-slider",
                    children: Children.toArray(children)
                }),
                controls && loaded && instanceRef.current && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Arrow, {
                            left: true,
                            onClick: function(e) {
                                var ref;
                                return e.stopPropagation() || ((ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.next());
                            },
                            disabled: currentSlide === 0,
                            style: "left:-10px; top:0; margin:auto; height:100%; cursor:pointer; position:absolute;"
                        }),
                        /*#__PURE__*/ _jsx(Arrow, {
                            onClick: function(e) {
                                var ref;
                                return e.stopPropagation() || ((ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.prev());
                            },
                            disabled: currentSlide === ((ref = instanceRef.current.track.details) === null || ref === void 0 ? void 0 : ref.slides.length) - 1,
                            style: "right:-10px; top:0; margin:auto; height:100%; cursor:pointer; position:absolute;"
                        })
                    ]
                })
            ]
        })
    });
}
function Arrow(props) {
    var disabeld = props.disabled ? " arrow--disabled" : "";
    var theme = useTheme();
    return /*#__PURE__*/ _jsxs("svg", {
        onClick: props.onClick,
        className: "arrow w-6 ".concat(props.className, " ").concat(props.left ? "arrow--left" : "arrow--right", " ").concat(disabeld),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: theme.colors.lightGray,
        css: /*#__PURE__*/ css(props.style),
        children: [
            props.left && /*#__PURE__*/ _jsx("path", {
                d: "M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
            }),
            !props.left && /*#__PURE__*/ _jsx("path", {
                d: "M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
            })
        ]
    });
}
/* harmony default export */ var base_ui_Carousel = ((/* unused pure expression or super */ null && (Carousel)));

;// CONCATENATED MODULE: ./src/features/base-ui/PartnerLogo.js





function PartnerLogo(param) {
    var imageSrc = param.imageSrc, caption = param.caption, customCaption = param.customCaption, style = param.style, _width = param.width, width = _width === void 0 ? "100px" : _width, _height = param.height, height = _height === void 0 ? "100px" : _height, _active = param.active, active = _active === void 0 ? false : _active;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var colored = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:linear-gradient(\n            45deg,#6366f1 0%,#a855f7 50%,#e74799 100%\n        );background-repeat:no-repeat;border-radius:100%;padding:3px;", style, ";");
    var solid = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", theme.colors.lighter, ";border-radius:100%;padding:3px;", style, ";");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "flex flex-col items-center text-center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: active ? colored : solid,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "rounded-full bg-white",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", width, ";height:", height, ";"),
                    children: imageSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "p-1",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            alt: caption,
                            src: imageSrc,
                            width: width,
                            height: height
                        })
                    })
                })
            }),
            caption && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Typography, {
                type: "p",
                color: "secondary",
                className: "mt-4",
                children: caption
            }),
            customCaption
        ]
    });
}
/* harmony default export */ var base_ui_PartnerLogo = (PartnerLogo);

;// CONCATENATED MODULE: ./src/features/base-ui/Divider.js




function Divider(param) {
    var _orientation = param.orientation, orientation = _orientation === void 0 ? "horizental" : _orientation, tight = param.tight, _width = param.width, width = _width === void 0 ? "100%" : _width, className = param.className, withGradient = param.withGradient, _depth = param.depth, depth = _depth === void 0 ? "1px" : _depth, _spacer = param.spacer, spacer = _spacer === void 0 ? "md" : _spacer, color = param.color, style = param.style;
    var paddingSwitch = function paddingSwitch(space) {
        var spacing = theme.spacing;
        switch(space){
            case "none":
                return 0;
            case "xs":
                return spacing.one;
            case "sm":
                return spacing.two;
            case "md":
                return spacing.four;
            case "lg":
                return spacing.six;
            case "xl":
                return spacing.eight;
            case "xxl":
                return spacing.ten;
            default:
                return spacing.six;
        }
    };
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var gradientStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border:none;background:linear-gradient(\n            45deg,", theme.colors.violet, " 0%,", theme.colors.primary, " 50%,", theme.colors.aquamarine, " 100%\n        );background-repeat:no-repeat;");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: orientation === "horizental" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
            className: (0,clsx_m/* default */.Z)(className),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(!tight && "margin-top: ".concat(paddingSwitch(spacer), ";\n                            margin-bottom: ").concat(paddingSwitch(spacer), ";"), " ", color && "border-color: ".concat(theme.colors[color]), ";display:block;", withGradient && gradientStyle, ";height:", depth, ";width:", width, ";", style, ";")
        })
    });
}
/* harmony default export */ var base_ui_Divider = (Divider);

;// CONCATENATED MODULE: ./src/features/base-ui/Title.js






function Title(param) {
    var children = param.children, className = param.className, _color = param.color, color = _color === void 0 ? "medGray" : _color, _size = param.size, size = _size === void 0 ? "lg" : _size, highlight = param.highlight, _highlightColor = param.highlightColor, highlightColor = _highlightColor === void 0 ? "primary" : _highlightColor, imgSrc = param.imgSrc, style = param.style;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var sizeSwitch = function(titleSize) {
        var fontSize = theme.fontSize;
        switch(titleSize){
            case "xs":
                return fontSize.xs;
            case "sm":
                return fontSize.sm;
            case "md":
                return fontSize.base;
            case "lg":
                return fontSize["2xl"];
            case "xl":
                return fontSize["3xl"];
            case "xxl":
                return fontSize["4xl"];
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)("flex items-center flex-wrap", className),
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(style),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui_Typography, {
            className: "px-2 flex items-center",
            type: "h3",
            fontWeight: "Semi Bold",
            color: color,
            transform: "uppercase",
            fontSize: sizeSwitch(size),
            children: [
                imgSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    alt: "forex rebate chart sign",
                    src: imgSrc,
                    width: 90,
                    height: 40
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "px-1",
                    dangerouslySetInnerHTML: {
                        __html: children === null || children === void 0 ? void 0 : children.replace(highlight, '<span style = "color: '.concat(theme.colors[highlightColor], '; text-decoration: underline;">').concat(highlight, "</span>"))
                    }
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_Title = (Title);

;// CONCATENATED MODULE: ./src/features/base-ui/TableCoins.js

function TableCoins_templateObject() {
    var data = _tagged_template_literal([
        "\n                                    font-family: ",
        ";\n                                "
    ]);
    TableCoins_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n                                font-family: ",
        ";\n                            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n                                direction: ltr;\n                                font-family: ",
        ";\n                            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n                                    direction: ltr;\n                                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n                                    font-family: ",
        ";\n                                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n                                    font-family: ",
        ";\n                                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






function CursorPagination(param) {
    var onChange = param.onChange;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    onChange === null || onChange === void 0 ? void 0 : onChange("prev");
                },
                children: "prev"
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    onChange === null || onChange === void 0 ? void 0 : onChange("next");
                },
                children: "next"
            })
        ]
    });
}
function TableCoins(param) {
    var _type = param.type, type = _type === void 0 ? "full" : _type, head = param.head;
    var ref;
    var theme = useTheme();
    var ref1 = useState({}), items = ref1[0], setItems = ref1[1];
    var ref2 = useState(true), loading = ref2[0], setLoading = ref2[1];
    var ref3 = useState(null), from_id = ref3[0], setFrom_id = ref3[1];
    useEffect(function() {
        fetch("/api/graphql", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                query: "{\n                    coinsLatest(meta: { limit: 10, from_id: ".concat(from_id ? '"'.concat(from_id, '"') : "null", " }) {\n                        from_id\n                        next_id\n                        prev_id\n                        data {\n                        id\n                        logo_path\n                        chart_path\n                        usd_price\n                        market_cap\n                        irr_price\n                        volume_24h\n                        symbol\n                        }\n                    }\n                }")
            })
        }).then(function(response) {
            return response.json();
        }).then(function(param) {
            var data = param.data;
            setItems(data === null || data === void 0 ? void 0 : data.coinsLatest);
            setLoading(false);
        }).catch(function() {
            setLoading(false);
        });
    }, [
        from_id
    ]);
    if (loading) return /*#__PURE__*/ _jsx(Typography, {
        type: "h4",
        color: "warning",
        children: "در حال بارگزاری"
    });
    else if (!(items === null || items === void 0 ? void 0 : items.length)) return /*#__PURE__*/ _jsx(Typography, {
        type: "h4",
        color: "danger",
        children: "خطا اتفاق افتاده"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Table, {
                head: head,
                children: items === null || items === void 0 ? void 0 : (ref = items.data) === null || ref === void 0 ? void 0 : ref.map(function(coin, idx) {
                    /*#__PURE__*/ return _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center px-2",
                                    css: css(TableCoins_templateObject(), theme.font.default),
                                    children: [
                                        /*#__PURE__*/ _jsx(Image, {
                                            alt: coin === null || coin === void 0 ? void 0 : coin.id,
                                            src: coin === null || coin === void 0 ? void 0 : coin.logo_path,
                                            width: 30,
                                            height: 30
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mx-1",
                                            children: coin === null || coin === void 0 ? void 0 : coin.id
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                css: css(_templateObject1(), theme.font.default),
                                children: currencyFormat(coin === null || coin === void 0 ? void 0 : coin.usd_price, "USD", "us-US")
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                css: css(_templateObject2(), theme.font.default),
                                children: (coin === null || coin === void 0 ? void 0 : coin.percent_change_1h) && /*#__PURE__*/ _jsx(ProfitOrLossCheck, {
                                    percentage: coin === null || coin === void 0 ? void 0 : coin.percent_change_1h.toFixed(3)
                                })
                            }),
                            type === "full" && /*#__PURE__*/ _jsx("td", {
                                css: css(_templateObject3()),
                                children: currencyFormat(coin === null || coin === void 0 ? void 0 : coin.irr_price, "IRR")
                            }),
                            type === "full" && /*#__PURE__*/ _jsx("td", {
                                css: css(_templateObject4(), theme.font.default),
                                children: currencyFormat(coin === null || coin === void 0 ? void 0 : coin.volume_24h, "USD", "us-US")
                            }),
                            type === "full" && /*#__PURE__*/ _jsxs("td", {
                                css: css(_templateObject5(), theme.font.default),
                                children: [
                                    " ",
                                    currencyFormat(coin === null || coin === void 0 ? void 0 : coin.market_cap, "USD", "us-US")
                                ]
                            }),
                            type === "full" && /*#__PURE__*/ _jsx("td", {
                                children: /*#__PURE__*/ _jsx(Image, {
                                    alt: coin === null || coin === void 0 ? void 0 : coin.id,
                                    src: coin === null || coin === void 0 ? void 0 : coin.chart_path,
                                    width: 100,
                                    height: 30
                                })
                            })
                        ]
                    }, idx);
                })
            }),
            type === "full" && /*#__PURE__*/ _jsx(CursorPagination, {
                onChange: function(action) {
                    switch(action){
                        case "prev":
                            setFrom_id(items === null || items === void 0 ? void 0 : items.prev_id);
                            break;
                        case "next":
                            setFrom_id(items === null || items === void 0 ? void 0 : items.next_id);
                            break;
                    }
                }
            })
        ]
    });
}
/* harmony default export */ var base_ui_TableCoins = ((/* unused pure expression or super */ null && (TableCoins)));

;// CONCATENATED MODULE: ./src/features/base-ui/Pagination.js




function Pagination(param) {
    var _pageItems = param.pageItems, pageItems = _pageItems === void 0 ? 10 : _pageItems, _allItems = param.allItems, allItems = _allItems === void 0 ? 100 : _allItems, _displayItems = param.displayItems, displayItems = _displayItems === void 0 ? 4 : _displayItems, url = param.url;
    var allPages = allItems / pageItems;
    var firstItem = currentPage > 1 ? (currentPage - 1) * pageItems + 1 : 1;
    var ref = useState(1), currentPage = ref[0], setCurrentPage = ref[1];
    var displayArray = function(start, stop, step) {
        return Array.from({
            length: (stop - start) / step + 1
        }, function(_, i) {
            return start + i * step;
        });
    };
    var ref1 = useState(displayArray(0, displayItems - 1, 1)), showArray = ref1[0];
    // const lastCoinExist = () => {
    //     if (firstItem) return '&last_coin_name='
    // }
    var PAGE_URL = [
        url,
        "/v1/latest?step=",
        pageItems,
        "&first_index=",
        firstItem
    ].join("");
    useEffect(function() {
        fetch(PAGE_URL).then(function(response) {
            return response.json();
        }).then(function() {}, //bug should use .catch
        function() {});
    }, [
        PAGE_URL,
        url
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pt-6 grid xl:grid-cols-3 justify-items-center",
        children: /*#__PURE__*/ _jsx(Card, {
            spacing: "md",
            shadow: "md",
            bordered: true,
            className: "xl:col-start-2",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage <= 1 ? "transparent" : "lighter",
                        onClick: function() {
                            return setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage);
                        },
                        disabled: currentPage <= 1,
                        children: /*#__PURE__*/ _jsx(BsArrowRightShort, {})
                    }),
                    currentPage > 1 && /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage === 1 ? "primary" : "lighter",
                        backgroundColor: currentPage === 1 ? "primary" : "white",
                        color: currentPage === 1 ? "white" : "text",
                        className: "mx-1",
                        onClick: function() {
                            setCurrentPage(1);
                        },
                        children: "1"
                    }),
                    currentPage > 2 && /*#__PURE__*/ _jsx("span", {
                        className: "mx-1",
                        children: "..."
                    }),
                    showArray.map(function(item, idx) {
                        return item + currentPage < allPages && /*#__PURE__*/ _jsx(Button, {
                            hoverColor: item + currentPage === currentPage ? "primary" : "lighter",
                            onClick: function() {
                                setCurrentPage(item + currentPage);
                            },
                            backgroundColor: item + currentPage === currentPage ? "primary" : "white",
                            color: item + currentPage === currentPage ? "white" : "text",
                            className: "mx-1",
                            children: item + currentPage
                        }, idx);
                    }),
                    currentPage < allPages - displayItems && /*#__PURE__*/ _jsx("span", {
                        className: "mx-1",
                        children: "..."
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage === allPages ? "primary" : "lighter",
                        backgroundColor: currentPage === allPages ? "primary" : "white",
                        color: currentPage === allPages ? "white" : "text",
                        className: "mx-1",
                        onClick: function() {
                            setCurrentPage(allPages);
                        },
                        children: allPages
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage >= allPages ? "transparent" : "lighter",
                        onClick: function() {
                            return setCurrentPage(currentPage < allPages ? currentPage + 1 : currentPage);
                        },
                        disabled: currentPage >= allPages,
                        children: /*#__PURE__*/ _jsx(BsArrowLeftShort, {})
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var base_ui_Pagination = ((/* unused pure expression or super */ null && (Pagination)));

;// CONCATENATED MODULE: ./src/features/base-ui/Section.js


function Section(param) {
    var children = param.children, backgroundImage = param.backgroundImage, backgroundColor = param.backgroundColor, _parallax = param.parallax, parallax = _parallax === void 0 ? false : _parallax, style = param.style;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(backgroundColor && "background-color: ".concat(theme.colors[backgroundColor]), ";background-repeat:no-repeat;", backgroundImage && "background-image: url(".concat(backgroundImage, "); background-size: cover; background-position: top;"), ";", parallax && "background-attachment: fixed;", ";", style, ";"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "px-6 lg:px-20 xl:px-28 2xl:px-52 mx-auto py-10",
            children: children
        })
    });
}
/* harmony default export */ var base_ui_Section = (Section);

;// CONCATENATED MODULE: ./src/features/base-ui/FeatureCard.js





function FeatureCard(param) {
    var title = param.title, description = param.description, iconSrc = param.iconSrc, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 80 : _iconSize, backgroundColor = param.backgroundColor, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.7 : _opacity;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    /* eslint-disable indent */ var featureStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", (0,Utility/* hexToRGB */.$W)(theme.colors[backgroundColor] || theme.colors.mainBackground, opacity), ";padding:1rem;box-shadow:", theme.boxShadow.default, ";display:flex;flex-direction:column;justify-content:center;align-items:center;width:15rem;height:15rem;border-radius:", theme.borderRadius.default, ";");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: featureStyle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                alt: title,
                src: iconSrc,
                width: iconSize,
                height: iconSize
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Typography, {
                type: "h6",
                color: "secondary",
                fontWeight: "Bold",
                className: "pt-2",
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Typography, {
                type: "p",
                color: "secondary",
                align: "center",
                fontSize: "1rem",
                lineHeight: 1.4,
                fontWeight: "Normal",
                className: "pt-2 w-40",
                children: description
            })
        ]
    });
}
/* harmony default export */ var base_ui_FeatureCard = (FeatureCard);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/features/base-ui/Form.js






function Form(_param) {
    var children = _param.children, onSubmit = _param.onSubmit, style = _param.style, width = _param.width, height = _param.height, backgroundColor = _param.backgroundColor, className = _param.className, _shadow = _param.shadow, shadow = _shadow === void 0 ? true : _shadow, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "onSubmit",
        "style",
        "width",
        "height",
        "backgroundColor",
        "className",
        "shadow"
    ]);
    var locale = (0,router.useRouter)().locale;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var rtl = [
        "ar",
        "fa"
    ].indexOf(locale) !== -1;
    var formStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:100%;.form-body{display:grid;align-content:center;height:100%;grid-template-columns:repeat(1,minmax(0,1fr));gap:5px;", "" /* padding: 1rem; */ , "}.form-control{font-size:", theme.fontSize.sm, ";width:100%;label{display:block;margin-bottom:0.5rem;}input,select,textarea{&[readonly]{background-color:transparent;pointer-events:none;border:none;}display:block;width:100%;border-radius:", theme.borderRadius.default, ";border:1px solid ", theme.colors.lightGray, ";padding:0.375rem 0.75rem;line-height:1.5;background-clip:padding-box;&:focus{color:", theme.colors.secGray, ";background-color:", theme.colors.white, ";border-color:", theme.colors.secondaryLight, ";outline:0;box-shadow:0 0 0 0.2rem rgb(149 163 255 / 25%);}}select{background-position:", rtl ? "left" : "right", " 0.5rem center;}}", style);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-radius:", theme.borderRadius.default, ";height:", height, ";width:", width, ";background-color:", theme.colors[backgroundColor] || theme.colors.mainBackground, ";", shadow && "box-shadow: ".concat(theme.boxShadow.md)),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSubmit: onSubmit,
            css: formStyle
        }, props), {
            children: children
        }))
    });
}
/* harmony default export */ var base_ui_Form = (Form);

;// CONCATENATED MODULE: ./src/features/base-ui/Accordion.js



function Accordion(param) {
    var title = param.title, content = param.content;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".accordion-title{display:flex;align-items:center;justify-content:space-between;padding:0.30rem 0.5rem;background-color:", theme.colors.transparent, ";border-radius:", theme.borderRadius.default, ";color:", theme.colors.primary, ";}.accordion-content{padding:0.5rem;color:", theme.colors.primary, ";}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "accordion",
        css: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "accordion-item",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "accordion-title outline outline-offset-4 outline-1",
                    onClick: function() {
                        return setIsActive(!isActive);
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "text-2xl",
                            children: isActive ? "-" : "+"
                        })
                    ]
                }),
                isActive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "accordion-content",
                    children: content
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_Accordion = (Accordion);

;// CONCATENATED MODULE: ./src/features/base-ui/index.js























/***/ }),

/***/ 2824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _webpage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12068);




function Layout(param) {
    var children = param.children;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: function(theme) {
            var ref, ref1;
            var ref2;
            return {
                color: theme.colors.text,
                fontFamily: (ref2 = (ref = theme.font[locale]) === null || ref === void 0 ? void 0 : ref.main) !== null && ref2 !== void 0 ? ref2 : (ref1 = theme.font["default"]) === null || ref1 === void 0 ? void 0 : ref1.main,
                backgroundColor: theme.colors.mainBackground,
                direction: [
                    "ar",
                    "fa"
                ].indexOf(locale) !== -1 ? "rtl" : "ltr",
                position: "relative"
            };
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_webpage__WEBPACK_IMPORTED_MODULE_2__/* .Head */ .Fb, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_webpage__WEBPACK_IMPORTED_MODULE_2__/* .Navbar */ .wp, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                children: children
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_webpage__WEBPACK_IMPORTED_MODULE_2__/* .Footer */ .$_, {})
        ]
    });
}


/***/ }),

/***/ 18995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30511);
/* harmony import */ var _base_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86481);






function EditorTypography(_param) {
    var type = _param.type, children = _param.children, allProbs = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "type",
        "children"
    ]);
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.a)();
    var typoSwitch = function(hType) {
        switch(hType){
            case "h1":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h1.fontSize,
                    lineHeight: theme.typography.h1.lineHeight,
                    fontWeight: theme.typography.h1.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "h2":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h2.fontSize,
                    lineHeight: theme.typography.h2.lineHeight,
                    fontWeight: theme.typography.h2.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "h3":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h3.fontSize,
                    lineHeight: theme.typography.h3.lineHeight,
                    fontWeight: theme.typography.h3.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "h4":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h4.fontSize,
                    lineHeight: theme.typography.h4.lineHeight,
                    fontWeight: theme.typography.h4.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "h5":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h5.fontSize,
                    lineHeight: theme.typography.h5.lineHeight,
                    fontWeight: theme.typography.h5.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "h6":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h6.fontSize,
                    lineHeight: theme.typography.h6.lineHeight,
                    fontWeight: theme.typography.h6.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "p":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.p.fontSize,
                    lineHeight: theme.typography.p.lineHeight,
                    fontWeight: theme.typography.p.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "t":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.t.fontSize,
                    lineHeight: theme.typography.t.lineHeight,
                    fontWeight: theme.typography.t.fontWeight
                }, allProbs), {
                    children: children
                }));
            case "div":
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .ZT, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.div.fontSize,
                    lineHeight: theme.typography.div.lineHeight,
                    fontWeight: theme.typography.div.fontWeight
                }, allProbs), {
                    children: children
                }));
        }
    };
    return typoSwitch(type);
}
/* harmony default export */ __webpack_exports__["Z"] = (EditorTypography);


/***/ }),

/***/ 12068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uo": function() { return /* reexport */ Brokercard; },
  "jP": function() { return /* reexport */ EditorTypography/* default */.Z; },
  "$_": function() { return /* reexport */ webpage_Footer; },
  "Fb": function() { return /* reexport */ Head; },
  "wp": function() { return /* reexport */ webpage_Navbar; },
  "mr": function() { return /* reexport */ webpage_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 1 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(30511);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 21 modules
var base_ui = __webpack_require__(86481);
// EXTERNAL MODULE: ./src/features/base-ui/Utility.js
var Utility = __webpack_require__(12774);
// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.esm.js
var index_esm = __webpack_require__(2585);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(42763);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
;// CONCATENATED MODULE: ./src/features/webpage/ChangeLanguage.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/alt-text */ 








function ChangeLanguage() {
    var expand = function expand() {
        setExpanded(true);
    };
    var close = function close() {
        setExpanded(false);
    };
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    var ref = (0,next_router.useRouter)(), locale = ref.locale, asPath = ref.asPath, locales = ref.locales;
    var ref1 = (0,react.useState)(false), expanded = ref1[0], setExpanded = ref1[1];
    var otherLocales = locales.filter(function(loc) {
        return loc !== locale;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        onBlur: close,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                className: "items-center justify-center",
                hoverColor: "secondary",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io_index_esm/* IoIosArrowDown */.OId, {}),
                onClick: function() {
                    if (expanded) close();
                    else expand();
                },
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("box-shadow:none;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: "/img/lang/".concat(locale, ".png"),
                    alt: "language",
                    width: 24,
                    height: 12
                })
            }),
            expanded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;text-align:center;margin-top:9px;position:absolute;background:#3a3d80;box-shadow:0 0 0 0.2rem rgb(149 163 255 / 50%);border-radius:0.25rem;> a{padding:8px 8px 8px;font-size:0.8rem;display:inline-flex;cursor:pointer;&:hover{filter:contrast(120%);background-color:#5a5fcd;}}"),
                children: otherLocales.map(function(loc) {
                    var ref;
                    var href = asPath;
                    if (data === null || data === void 0 ? void 0 : (ref = data.changeLangOverrides) === null || ref === void 0 ? void 0 : ref[loc]) href = data.changeLangOverrides[loc];
                    // if (typeof pathMap === 'string') href = pathMap
                    // else if (pathMap !== null && pathMap[loc])
                    //     href = pathMap[loc]
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: href,
                        locale: loc,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            onMouseDown: function(e) {
                                e.preventDefault();
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                src: "/img/lang/".concat(loc, ".png"),
                                width: 32,
                                height: 16
                            })
                        })
                    }, loc);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/User/index.js + 3 modules
var User = __webpack_require__(34544);
;// CONCATENATED MODULE: ./src/features/webpage/Navbar.jsx
/* eslint-disable react/jsx-no-target-blank */ 












// import { useDataProvider } from '../../hooks/dataProvider'
/* eslint-disable indent */ function Navbar() {
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    // const [bgColor, setBgColor] = useState(false)
    // const changeBg = () => {
    //     if (window.scrollY >= 80) {
    //         setBgColor(true)
    //     } else {
    //         setBgColor(false)
    //     }
    // }
    // window.addEventListener('scroll', changeBg)
    // const bgSticky = '#333333ef'
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    var homeNavbar = data === null || data === void 0 ? void 0 : data.homeNav;
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var user = (0,User/* useUser */.aF)();
    var showDrawer = function() {
        setVisible(true);
    };
    var onClose = function() {
        setVisible(false);
    };
    var menuStyle = "\n        a {\n            padding: 0 0.25rem;\n            font-weight: 600;\n        };\n        border-radius: ".concat(theme.borderRadius.default, ";\n        &:hover {\n            background-color: ").concat(theme.colors.secondary, "; \n        }\n\n    ");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "lg:hidden w-screen h-screen -top-0 bg-gray-600 bg-opacity-20 z-20 backdrop-filter backdrop-blur-sm ".concat(visible ? "block" : "hidden"),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("right:0;left:auto;position:fixed;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "slideMenu w-64 bg-white float-left px-6 h-full\n            ".concat(visible ? "slideEnter" : "hidden"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            className: "mt-4 w-8",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cg_index_esm/* CgCloseR */.hhk, {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:", theme.fontSize.x2l, ";color:", theme.colors.secondaryLight, ";")
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "mt-10",
                            children: [
                                user.isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                            href: "/dashboard",
                                            type: "linkButton",
                                            color: "secondary",
                                            size: "small",
                                            backgroundColor: "primary",
                                            style: "padding-right: 0.5rem; padding-left: 0.5rem;",
                                            children: t("dashboard")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "mr-4 ml-4",
                                            children: "|"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                            href: "/api/auth/signout",
                                            type: "linkButton",
                                            color: "lighterGray",
                                            size: "small",
                                            backgroundColor: "secondary",
                                            style: "padding-right: 0.5rem; padding-left: 0.5rem;",
                                            children: t("signout")
                                        })
                                    ]
                                }),
                                !user.isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                    href: "/auth/signin",
                                    type: "linkButton",
                                    color: "lighterGray",
                                    size: "small",
                                    backgroundColor: "secondary",
                                    style: "padding-right: 0.5rem; padding-left: 0.5rem;",
                                    children: t("login")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            className: "mt-10 capitalize",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("a{border-bottom:3px solid\n                                    ", theme.colors.secondaryLight, ";padding:0.25rem;color:", theme.colors.secondary, ";}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mb-10",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/",
                                        onClick: onClose,
                                        children: t("home")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mb-10",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/brokers",
                                        onClick: onClose,
                                        children: t("brokers")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mb-10",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/charts",
                                        onClick: onClose,
                                        children: t("charts")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mb-10",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/blog",
                                        onClick: onClose,
                                        children: t("blog")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mb-10",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/about",
                                        onClick: onClose,
                                        children: t("about us")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mb-10",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/contact",
                                        onClick: onClose,
                                        children: t("contact us")
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("header", {
                className: "flex py-4 px-6 lg:px-20 xl:px-28 2xl:px-52 items-center w-full",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("z-index:9;top:0;", homeNavbar && "position: fixed; left: 50%; transform: translate(-50%, 0); background-color: #e9e9e985; backdrop-filter: blur(10px)", ";", !homeNavbar && "position: sticky; background-color: ".concat(theme.colors.mainBackground, "; margin: 0 auto;"), ";"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;gap:10px;", (0,Utility/* MediaQuery */.zP)("lg", "min"), "{display:none;}"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                        onClick: showDrawer,
                                        color: "secondary",
                                        backgroundColor: "primary",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* GiHamburgerMenu */.vHB, {})
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangeLanguage, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "hidden lg:flex items-center justify-center",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", homeNavbar ? theme.colors.lighterGray : theme.colors.secondaryLight, ";"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangeLanguage, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        className: "ms-1 me-4",
                                        children: "|"
                                    }),
                                    user.isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                                href: "/dashboard",
                                                type: "linkButton",
                                                color: "secondary",
                                                size: "small",
                                                backgroundColor: "primary",
                                                style: "padding-right: 1rem; padding-left: 1rem;",
                                                children: t("dashboard")
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                className: "mr-4 ml-4",
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                                href: "/api/auth/signout",
                                                type: "linkButton",
                                                color: "lighterGray",
                                                size: "small",
                                                backgroundColor: "secondary",
                                                style: "padding-right: 1rem; padding-left: 1rem;",
                                                children: t("signout")
                                            })
                                        ]
                                    }),
                                    !user.isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                        href: "/auth/signin",
                                        type: "linkButton",
                                        color: "lighterGray",
                                        size: "small",
                                        backgroundColor: "secondary",
                                        style: "padding-right: 1rem; padding-left: 1rem;",
                                        children: t("login")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "bg-white absolute"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "hidden lg:flex 2xl:w-2/5 ".concat(router.locale === "en" ? "ml-auto lg:mr-10" : "mr-auto lg:ml-10"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            className: "flex w-full xl:justify-evenly capitalize flex-wrap",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mx-1",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/",
                                        style: menuStyle,
                                        hoverColor: "lighterGray",
                                        color: "secondary",
                                        children: t("home")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mx-1",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/brokers",
                                        style: menuStyle,
                                        hoverColor: "lighterGray",
                                        color: "secondary",
                                        children: t("brokers")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mx-1",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/charts",
                                        style: menuStyle,
                                        hoverColor: "lighterGray",
                                        color: "secondary",
                                        children: t("charts")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mx-1",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/blog",
                                        style: menuStyle,
                                        hoverColor: "lighterGray",
                                        color: "secondary",
                                        children: t("blog")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mx-1",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/about",
                                        style: menuStyle,
                                        hoverColor: "lighterGray",
                                        color: "secondary",
                                        children: t("about us")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "mx-1",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: "/contact",
                                        style: menuStyle,
                                        hoverColor: "lighterGray",
                                        color: "secondary",
                                        children: t("contact us")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                        href: "/",
                        className: "lg:m-0 ".concat(router.locale === "en" ? "ml-auto" : "mr-auto"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            width: "100",
                            height: "40",
                            alt: "logo",
                            src: "/img/shared/logo.png"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var webpage_Navbar = (Navbar);

// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./src/features/webpage/EditorTypography.jsx
var EditorTypography = __webpack_require__(18995);
;// CONCATENATED MODULE: ./src/features/webpage/Footer.jsx
/* eslint-disable react/jsx-no-target-blank */ 







function Footer() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var t = (0,esm/* useTranslation */.$G)().t;
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var pulse = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("from{transform:scale3d(1,1,1);}50%{transform:scale3d(1.15,1.15,1.15);}to{transform:scale3d(1,1,1);}");
    var goToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
        className: "block w-full float-right relative",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "grid md:grid-cols-2 lg:grid-cols-5 pt-10 pb-20 lg:py-10 px-6 lg:px-20 2xl:px-52 relative",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:url('/img/footer-background.png'),", theme.colors.text, ";background-size:cover;background-position:top;color:", theme.colors.white, ";"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "lg:col-span-3 lg:px-10",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            alt: "forexrebate logo",
                            src: "/img/shared/logo.png",
                            placeholder: "empty",
                            width: 150,
                            height: 64,
                            style: {
                                filter: "brightness(0) invert(1)"
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                            type: "p",
                            fontSize: "1rem",
                            color: "white",
                            className: "pt-4 pb-10",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: data === null || data === void 0 ? void 0 : (ref = data.footerData) === null || ref === void 0 ? void 0 : (ref1 = ref.sections) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.content
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "py-6 lg:pt-0 lg:px-4 md:mx-0 md:mr-10 lg:mr-0",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                            type: "h6",
                            color: "white",
                            children: t("quick access")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            className: "list-disc list-inside pt-2 lg:pt-6",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", theme.colors.primary, ";"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        color: "white",
                                        href: "/",
                                        children: t("home")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        color: "white",
                                        href: "/brokers",
                                        children: t("brokers")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        color: "white",
                                        href: "/charts",
                                        children: t("charts")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        color: "white",
                                        href: "/blog",
                                        children: t("blog")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        color: "white",
                                        href: "/about",
                                        children: t("about us")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        color: "white",
                                        href: "/contact",
                                        children: t("contact us")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "lg:px-4 py-6 lg:pt-0 md:mr-10 lg:mr-0",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                            type: "h6",
                            color: "white",
                            children: t("contact us")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            className: "text-gray-silver pt-2 lg:pt-6",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    className: "py-2 flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                            alt: "socials",
                                            src: "/img/footer/socials/phone.svg",
                                            width: 32,
                                            height: 32
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                            href: "tel:02188888889",
                                            color: "white",
                                            external: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                dir: "ltr",
                                                className: "mx-2",
                                                children: data === null || data === void 0 ? void 0 : (ref3 = data.contactData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sections) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.content
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    className: "py-2 flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                            alt: "socials",
                                            src: "/img/footer/socials/mail.svg",
                                            width: 32,
                                            height: 32
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                            href: "mailto:cryptoline@gmail.com",
                                            color: "white",
                                            external: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                dir: "ltr",
                                                className: "mx-2",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:", theme.fontSize.sm, ";"),
                                                children: data === null || data === void 0 ? void 0 : (ref6 = data.contactData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sections) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[1]) === null || ref8 === void 0 ? void 0 : ref8.content
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    className: "py-2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        dir: "ltr",
                                        className: "",
                                        children: data === null || data === void 0 ? void 0 : (ref9 = data.contactData) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.sections) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[2]) === null || ref11 === void 0 ? void 0 : ref11.content
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "flex mt-6 w-36 mb-6 lg:mb-20 justify-around",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                    external: true,
                                    href: data === null || data === void 0 ? void 0 : (ref12 = data.contactData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sections) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[10]) === null || ref14 === void 0 ? void 0 : ref14.content,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "socials",
                                        src: "/img/footer/socials/telegram.svg",
                                        width: 32,
                                        height: 32
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                    external: true,
                                    href: data === null || data === void 0 ? void 0 : (ref15 = data.contactData) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.sections) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[11]) === null || ref17 === void 0 ? void 0 : ref17.content,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "socials",
                                        src: "/img/footer/socials/instagram.svg",
                                        width: 32,
                                        height: 32
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                    external: true,
                                    href: data === null || data === void 0 ? void 0 : (ref18 = data.contactData) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.sections) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[12]) === null || ref20 === void 0 ? void 0 : ref20.content,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "socials",
                                        src: "/img/footer/socials/youtube.svg",
                                        width: 32,
                                        height: 32
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                    external: true,
                                    href: data === null || data === void 0 ? void 0 : (ref21 = data.contactData) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.sections) === null || ref22 === void 0 ? void 0 : (ref23 = ref22[13]) === null || ref23 === void 0 ? void 0 : ref23.content,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "socials",
                                        src: "/img/footer/socials/twitter.svg",
                                        width: 32,
                                        height: 32
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "text-center fixed bottom-10 z-10 right-4 lg:right-10",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover a{animation:", pulse, " 1s ease-in-out infinite;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                        color: "lightGray",
                        onClick: goToTop,
                        style: "padding: 0; box-shadow: none; &:hover {box-shadow: none;}",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsFillArrowUpSquareFill */.ULj, {
                            className: "text-3xl",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", theme.colors.secondaryLight, ";")
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: "v1.12.2"
                })
            ]
        })
    });
}
/* harmony default export */ var webpage_Footer = (Footer);

;// CONCATENATED MODULE: ./src/features/webpage/PageHeader.jsx






function PageHeader(param) {
    var _color = param.color, color = _color === void 0 ? "lighterGray" : _color, title = param.title, highlight = param.highlight, _parallax = param.parallax, parallax = _parallax === void 0 ? true : _parallax, _highlightColor = param.highlightColor, highlightColor = _highlightColor === void 0 ? "primary" : _highlightColor, _breadcrumb = param.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, style = param.style;
    var locale = (0,next_router.useRouter)().locale;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var breadcrumbStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;", (0,Utility/* MediaQuery */.zP)("md", "max"), "{justify-content:center;}.breadcrumb-item{display:flex;align-items:center;.breadcrumb-splitter{display:flex;align-items:center;}}.breadcrumb-item:last-child{a{color:", theme.colors.primary, ";}.breadcrumb-splitter{display:none;}}");
    var containerStyle = "padding: 5rem 0 5rem 0; ".concat(style);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
        backgroundImage: "/img/home/how/home-how-background.jpg",
        style: containerStyle,
        parallax: parallax,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                color: color,
                highlightColor: highlightColor,
                highlight: highlight,
                imgSrc: "/img/svg/title-line.svg",
                style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "breadcrumb",
                css: breadcrumbStyle,
                children: breadcrumb.map(function(item, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "breadcrumb-item",
                        children: [
                            item.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                href: item.url,
                                color: "lighterGray",
                                children: item.text
                            }),
                            !item.url && item.text,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                className: "breadcrumb-splitter mx-2 ".concat(locale === "en" && "rotate-180"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                    alt: "breadcrumb-item",
                                    src: "/img/svg/arrowLeft-primary.svg",
                                    width: 22,
                                    height: 22
                                })
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
}
/* harmony default export */ var webpage_PageHeader = (PageHeader);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
;// CONCATENATED MODULE: ./src/features/webpage/Head.js




function Head(param) {
    var title = param.title;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "icon",
                        href: "/img/favicon/favicon-32x32.png"
                    })
                ]
            }),
            ((ref = config.integrations) === null || ref === void 0 ? void 0 : ref.umami) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                async: true,
                defer: true,
                "data-website-id": config.integrations.umami.websiteId,
                src: "https://analytics.jeldnews.com/umami.js"
            }),
            ((ref1 = config.integrations) === null || ref1 === void 0 ? void 0 : ref1.tawk) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                        id: "tawk_pre",
                        dangerouslySetInnerHTML: {
                            __html: "var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                        id: "tawk",
                        async: true,
                        charset: "UTF-8",
                        crossorigin: "*",
                        src: "https://embed.tawk.to/".concat(config.integrations.tawk.id)
                    })
                ]
            }),
            ((ref2 = config.integrations) === null || ref2 === void 0 ? void 0 : ref2.enjaneb) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                async: true,
                id: config.integrations.enjaneb.id,
                enjaneb_protection_ID: config.integrations.enjaneb.token,
                src: "https://www.enjaneb.com/sciipt/accenj.js"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(97899);
;// CONCATENATED MODULE: ./src/features/webpage/BrokerCard.jsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                            ",
        " {\n                                                font-size: ",
        ";\n                                            }\n                                        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function Brokercard(param) {
    var _broker = param.broker, broker = _broker === void 0 ? {} : _broker;
    var ref, ref1;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var link = (0,utils/* generateUrl */.nu)(broker, "broker");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Card */.Zb, {
                type: "horizental",
                imgSrc: (broker === null || broker === void 0 ? void 0 : (ref = broker.logo) === null || ref === void 0 ? void 0 : ref.hash) && "/api/filedb/".concat(broker.logo.hash, ".").concat(broker.logo.ext),
                imgWidth: 200,
                imgHeight: 200,
                bordered: true,
                imgFullRound: true,
                className: "relative",
                style: ".card-footer {\n                ".concat((0,Utility/* MediaQuery */.zP)("lg", "max"), " {\n                    display: none;\n                }\n            }\n            \n            ").concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {\n                flex-direction: column;\n                align-items: center;\n            }\n            "),
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                    type: "h4",
                    fontWeight: "Bold",
                    align: "left",
                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {font-size: ").concat(theme.fontSize.lg, "; text-align:center;}"),
                    children: broker.title
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "flex flex-wrap justify-center lg:justify-start lg:pt-4 pt-2",
                    dir: "ltr",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "lg:flex lg:flex-col text-left lg:flex-wrap lg:pr-4 basis-1/2",
                            children: (ref1 = broker.attrs_list_page) === null || ref1 === void 0 ? void 0 : ref1.map(function(a, i) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                            type: "h6",
                                            align: "left",
                                            style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {\n                        font-size: ").concat(theme.fontSize.base, ";\n                        padding-top:0.5rem;\n                    }"),
                                            children: a.key
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), (0,Utility/* MediaQuery */.zP)("md", "max"), theme.fontSize.sm),
                                            children: a.value
                                        })
                                    ]
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                            backgroundColor: "secondary",
                            color: "lighterGray",
                            className: "mr-auto",
                            style: "".concat((0,Utility/* MediaQuery */.zP)("lg", "min"), " {\n                    display: none;\n                }; ").concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {font-size: ").concat(theme.fontSize.sm, ";\n                    flex-basis: 100%;\n                    flex-grow: 2;\n                    margin-top: 1rem;\n                };"),
                            children: "باز کردن اکانت"
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/webpage/index.js








/***/ }),

/***/ 46766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x5": function() { return /* reexport */ useDataProvider; }
});

// UNUSED EXPORTS: DataProvider, DataProviderContext

// EXTERNAL MODULE: ./src/hooks/dataProvider/DataProviderContext.js
var DataProviderContext = __webpack_require__(36651);
// EXTERNAL MODULE: ./src/hooks/dataProvider/DataProvider.js
var DataProvider = __webpack_require__(94571);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/dataProvider/useDataProvider.js


function useDataProvider() {
    var data = (0,react.useContext)(DataProviderContext/* DataProviderContext */.C);
    if (data === undefined) {
        throw new Error("useData must be used within a DataProvider");
    }
    return data;
}

;// CONCATENATED MODULE: ./src/hooks/dataProvider/index.js





/***/ }),

/***/ 1709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ hashIds; },
/* harmony export */   "Jr": function() { return /* binding */ unhashIds; }
/* harmony export */ });
/* unused harmony exports hashHex, unhashHex */
/* harmony import */ var hashids__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93589);

var hashing = new hashids__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("", 6, "0123456789abcdefghijklmnopqrstuvwxyz");
function hashIds(id) {
    return hashing.encode(id);
}
function hashHex(id) {
    return hashing.encodeHex(id);
}
function unhashIds(id) {
    return hashing.decode(id);
}
function unhashHex(id) {
    return hashing.decodeHex(id);
}


/***/ }),

/***/ 97899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nu": function() { return /* reexport */ generateUrl; },
  "eZ": function() { return /* reexport */ normalizeNumbers; },
  "dD": function() { return /* reexport */ parseQueryString; }
});

// UNUSED EXPORTS: deduceOp, distanceFromNow, findDeep, hashHex, hashIds, jizes, matchesDeep, num_a2e, num_a2p, num_e2a, num_e2p, num_p2a, num_p2e, sleep, toPersian, unhashHex, unhashIds

;// CONCATENATED MODULE: ./src/utils/string.js

var PERSIAN_NUMBERS = "۰۱۲۳۴۵۶۷۸۹";
var ARABIC_NUMBERS = "٠١٢٣٤٥٦٧٨٩";
var ARABIC_TO_PERSIAN_MAP = {
    ك: "ک",
    دِ: "د",
    بِ: "ب",
    زِ: "ز",
    ذِ: "ذ",
    شِ: "ش",
    سِ: "س",
    ى: "ی",
    ي: "ی"
};
function toPersian(text) {
    if (!text) return text;
    text = text + "";
    for(var i = 0; i < 10; i++){
        var replaceArToFa = new RegExp(ARABIC_NUMBERS[i], "g");
        var replaceEnToFa = new RegExp(i, "g");
        text = text.replace(replaceArToFa, PERSIAN_NUMBERS[i]).replace(replaceEnToFa, PERSIAN_NUMBERS[i]);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(ARABIC_TO_PERSIAN_MAP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), arabic = _value[0], persian = _value[1];
            var replaceFn = new RegExp(arabic, "g");
            text = text.replace(replaceFn, persian);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
var num_e2p = function(s) {
    return s === null || s === void 0 ? void 0 : s.replace(/\d/g, function(d) {
        return PERSIAN_NUMBERS[d];
    });
};
var num_e2a = function(s) {
    return s === null || s === void 0 ? void 0 : s.replace(/\d/g, function(d) {
        return ARABIC_NUMBERS[d];
    });
};
var num_p2e = function(s) {
    return s === null || s === void 0 ? void 0 : s.replace(/[۰-۹]/g, function(d) {
        return PERSIAN_NUMBERS.indexOf(d);
    });
};
var num_a2e = function(s) {
    return s === null || s === void 0 ? void 0 : s.replace(/[٠-٩]/g, function(d) {
        return ARABIC_NUMBERS.indexOf(d);
    });
};
var num_p2a = function(s) {
    return s === null || s === void 0 ? void 0 : s.replace(/[۰-۹]/g, function(d) {
        return ARABIC_NUMBERS[PERSIAN_NUMBERS.indexOf(d)];
    });
};
var num_a2p = function(s) {
    return s === null || s === void 0 ? void 0 : s.replace(/[٠-٩]/g, function(d) {
        return PERSIAN_NUMBERS[ARABIC_NUMBERS.indexOf(d)];
    });
};
var normalizeNumbers = function(text) {
    return num_a2e(num_p2e(text));
};

// EXTERNAL MODULE: ./src/utils/hashId.js
var hashId = __webpack_require__(1709);
;// CONCATENATED MODULE: ./src/utils/links.js

function generateUrl(entity, type) {
    if (!entity) return "";
    if (type === "news") {
        var ref, ref1, ref2;
        if (!entity.ext_id) {
            console.warn("can't generate url for news, need ext_id", entity);
            return "";
        }
        var ref3;
        var slug = entity.seo_slug ? entity.seo_slug.replace(/\s/g, "-") : (ref3 = (ref2 = (ref1 = (ref = entity.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.replace(/[^\u0600-\u06FFa-zA-Z]/g, "-")) === null || ref2 === void 0 ? void 0 : ref2.replace(/-{2,}/g, "-")) !== null && ref3 !== void 0 ? ref3 : null;
        var id = (0,hashId/* hashIds */.HY)(entity.ext_id);
        return "/blog/".concat(id).concat(slug ? "/" + slug : "");
    }
    if (type === "broker") {
        var ref4, ref5, ref6;
        var ref7;
        var slug1 = (ref7 = (ref6 = (ref5 = (ref4 = entity.title) === null || ref4 === void 0 ? void 0 : ref4.trim()) === null || ref5 === void 0 ? void 0 : ref5.replace(/[^\u0600-\u06FFa-zA-Z]/g, "-")) === null || ref6 === void 0 ? void 0 : ref6.replace(/-{2,}/g, "-")) !== null && ref7 !== void 0 ? ref7 : null;
        return "/brokers".concat(slug1 ? "/" + slug1 : "");
    }
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/utils/matchesDeep.js


function matchesDeep(object, source) {
    var results = [];
    if (isMatch(object, source)) results.push([
        "."
    ]);
    innerFindRecursive(object, source, [], results);
    return results;
}
function innerFindRecursive(object, source) {
    var rootPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], results = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    forOwn(object, function(value, key) {
        if (isObjectLike(value)) {
            if (isMatch(value, source)) results.push(_to_consumable_array(rootPath).concat([
                key
            ]));
            //we recurse
            innerFindRecursive(value, source, _to_consumable_array(rootPath).concat([
                key
            ]), results);
        }
    });
}
function findDeep(object, sources) {
    var results = [];
    forOwn(object, function(value, key) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var source = _step.value;
                if (key === source) results.push([
                    key
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    innerFind2Recursive(object, sources, [], results);
    return results;
}
function innerFind2Recursive(object, sources) {
    var rootPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], results = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    forOwn(object, function(value, key) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var source = _step.value;
                if (isObjectLike(value)) {
                    if (has(value, source)) results.push(_to_consumable_array(rootPath).concat([
                        key,
                        source
                    ]));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (isObjectLike(value)) innerFind2Recursive(value, sources, _to_consumable_array(rootPath).concat([
            key
        ]), results);
    });
}

;// CONCATENATED MODULE: ./src/utils/queryString.js
function parseQueryString() {
    if (false) {}
    return new Proxy(new URLSearchParams(window.location.search), {
        get: function(searchParams, prop) {
            var par = searchParams.get(prop);
            return par === "" ? true : par;
        }
    });
}

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/jalaliday/dist/jalaliday.esm.js
var jalaliday_esm = __webpack_require__(95888);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__(84110);
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);
;// CONCATENATED MODULE: ./src/utils/date.js



dayjs_min_default().extend((relativeTime_default()));
dayjs_min_default().extend(jalaliday_esm/* default */.Z);
function distanceFromNow(date1) {
    if (!date1) return "";
    return dayjs(date1).locale("fa").fromNow();
}

;// CONCATENATED MODULE: ./src/utils/index.js











/***/ })

}]);